import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Link, Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import TranslatedText from "../../../utils/Translate"
import { Chip, IconButton, Modal, Paper, Tooltip } from "@mui/material"
import CodeMirror from '@uiw/react-codemirror';
import { materialLight } from "@uiw/codemirror-theme-material"
import { langs } from "@uiw/codemirror-extensions-langs"
import { languages } from "@codemirror/language-data"
import { markdown, markdownLanguage } from "@codemirror/lang-markdown"
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { javascript } from "@codemirror/lang-javascript";
import { LanguageSupport } from "@codemirror/language";
import { LanguageDescription } from "@codemirror/language";
import { useSnackbar } from "../../../utils/SnackbarContext"


export default function AIPrompt() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [aiFunctions, setAiFunctions] = useState([])
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [currentParameter, setCurrentParameter] = React.useState('0');

    const { showSnackbar } = useSnackbar();

    const [parameters, setParameters] = React.useState([
        {
            name: 'answer',
            description: 'Put your answer in this variable',
            required: '1',
            options: 'да.нет'
        },
        {
            name: 'answer1',
            description: 'Put your answer in this variable',
            required: '1',
            options: 'да.нет'
        },
        {
            name: 'answer2',
            description: 'Put your answer in this variable',
            required: '1',
            options: 'да.нет'
        },
    ]);

    const handleParametrsListChange = (event: React.SyntheticEvent, newValue: string) => {
        setCurrentParameter(newValue);
    };

    const handleDeleteModalOpen = (id: any) => {
        setOpenDeleteModal(id)
    };
    const handleEditModalOpen = (id: any) => {
        setOpenEditModal(id)
    };
    const handleDeleteModalClose = () => setOpenDeleteModal(false);
    const handleEditModalClose = () => setOpenEditModal(false);

    const [AIFunc, setAIFunc] = useState([
        {
            name: 'test func',
            description: 'Call this functionCall this functionCall this functionCall this functionCall this functionCall this functionCall this functionCall this functionCall this functionCall this function',
            api_code: 'echo 123'
        },
        {
            name: 'test func 1',
            description: 'Call this function',
            api_code: 'echo 123'
        },
        {
            name: 'test func 2',
            description: 'Call this function',
            api_code: 'echo 123'
        },
        {
            name: 'test func 3',
            description: 'Call this function',
            api_code: 'echo 123'
        },
        {
            name: 'test func 4',
            description: 'Call this function',
            api_code: 'echo 123'
        },
        {
            name: 'test func 5',
            description: 'Call this function',
            api_code: 'echo 123'
        },
    ])

    const Modalstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 400,
        maxWidth: 800,
        width: '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };

    const EditModalstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 400,
        maxWidth: 1500,
        maxHeight: '90%',

        width: '70%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title
    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit AI Prompt` : 'Add AI Prompt'))
    }, [dispatch]);


    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get did
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/aiprompt/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setAIPromptData({ ...response.data[0], prompt: response.data[0].prompt || '', tools: response.data[0].tools != undefined ? JSON.parse(response.data[0].tools).join('\n') : '' })
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create did
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/aiprompt`, {
                ...AIPromptData, tools: AIPromptData.tools !== undefined ? JSON.stringify(AIPromptData.tools.split('\n')) : ''
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit did
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/aiprompt/${id}`, {
                ...AIPromptData, tools: AIPromptData.tools !== undefined ? JSON.stringify(AIPromptData.tools.split('\n')) : ''
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [AIPromptData, setAIPromptData] = useState<any>(type === 'edit' ? [] :
        {
            "name": '',
            "code": '',
            "prompt": '',
            "tool_choice": 'auto',
            "tools": '',
        }
    )

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get ai functions
    // async function getAIFunctions(params: object = {}) {
    //     try {
    //         const response = await axios.get(`https://cardgarantsales.com/restapi/aifunctions`, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 "Authorization": "Bearer " + localStorage.getItem('access_token')
    //             }, params: params
    //         })
    //         console.log(response.data);
    //         setAiFunctions(response.data)
    //     } catch (error: any) {
    //         console.log(error);
    //         if (error.message === "Request failed with status code 401") {
    //             logOut(dispatch)
    //         }
    //         else if (error.code === "ERR_NETWORK") {
    //             showSnackbar('ERROR NETWORK', 'error')
    //         }
    //     }
    // }

    // async function handleDeleteFunction(id: any) {
    //     try {
    //         const response = await axios.delete(`https://cardgarantsales.com/restapi/aifunctions/` + id, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 "Authorization": "Bearer " + localStorage.getItem('access_token')
    //             },
    //         })
    //         setAiFunctions(aiFunctions.filter((row:any) => row.id !== id))
    //         handleDeleteModalClose()
    //     } catch (error: any) {
    //         console.log(error);
    //         if (error.code === "ERR_BAD_REQUEST") {
    //             logOut(dispatch)
    //         }
    //         else if (error.code === "ERR_NETWORK") {
    //             showSnackbar('ERROR NETWORK', 'error')
    //         }
    //     }
    // }



    //On load if URL params contains type=edit - get data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        type === 'edit' && fetchData()
        accesslevel === "5" && getPartners()
        // type === 'edit' && getAIFunctions({ aiprompt: id })
        console.log(AIPromptData);

    }, [])

    const truncateString = (s: string, w: number) => s.length > w ? s.slice(0, w) + "..." : s;

    function customLanguage() {
        return new LanguageSupport(javascript().language);
    }

    const customLangDescription = LanguageDescription.of({
        name: "code",
        support: customLanguage()
    });


    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Paper elevation={3} sx={{ width: '60%', minWidth: 500, maxWidth: 1200, height: '80vh', padding: 2, display: 'flex', flexDirection: 'column', }}>
                    <Typography sx={{ width: '100%', mb: 2 }} variant="h5"><TranslatedText text={'AI Prompt Text'} /></Typography>
                    <Box sx={{ overflow: 'auto', p: 2 }}>
                        <CodeMirror
                            width="auto"
                            onChange={(e) => setAIPromptData({ ...AIPromptData, prompt: e !== '' ? e : '' })}
                            value={AIPromptData.prompt}
                            theme={materialLight} extensions={[
                                // markdown({ codeLanguages: [customLangDescription] }),
                                langs.javascript(),
                            ]} />
                    </Box>


                </Paper>
                <Box sx={{ width: '30%', minWidth: 600, height: '80vh', display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Paper elevation={3} sx={{ padding: 2, flex: 1 }}>
                        <Typography sx={{ width: '100%', mb: 2 }} variant="h5"><TranslatedText text={'Main settings'} /></Typography>
                        <Box sx={{ p: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                            <TextField onChange={(e) => setAIPromptData({ ...AIPromptData, name: e.target.value !== '' ? e.target.value : null })} value={AIPromptData.name || ''} sx={{ width: "100%" }} variant="outlined" size="small" label={<TranslatedText text={'Name'} />} />
                            <TextField onChange={(e) => setAIPromptData({ ...AIPromptData, code: e.target.value !== '' ? e.target.value : null })} value={AIPromptData.code || ''} sx={{ width: "100%" }} variant="outlined" size="small" label={<TranslatedText text={'Code'} />} />
                            <FormControl sx={{ width: "100%" }}>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Function call mode'} /></InputLabel>
                                <Select onChange={(e) => setAIPromptData({ ...AIPromptData, tool_choice: e.target.value !== '' ? e.target.value : null })} value={AIPromptData.tool_choice || ''} sx={{ width: "100%" }} labelId="simple-select-label" variant="outlined" size="small" label={<TranslatedText text={'Function call mode'} />}>
                                    <MenuItem value={'auto'}>auto</MenuItem>
                                    <MenuItem value={'required'}>required</MenuItem>
                                    <MenuItem value={'none'}>none</MenuItem>
                                    {aiFunctions.map((el: any) => {
                                        return (
                                            <MenuItem key={el.id} value={el.name}>{el.name}</MenuItem>
                                        )
                                    })
                                    }
                                </Select>
                            </FormControl>
                            {accesslevel === "5" &&
                                <>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Available to partners"} /></InputLabel>
                                        <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setAIPromptData({ ...AIPromptData, partner: e.target.value !== "" ? e.target.value : null })} value={AIPromptData.partner || ''} variant="outlined" size="small" label={<TranslatedText text={"Available to partners"} />} >
                                            <MenuItem value={''}>Only Operator</MenuItem>
                                            <MenuItem value={'0'}>All</MenuItem>
                                            {
                                                partners.map((el: any) => {
                                                    return (
                                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </>
                            }
                            {accesslevel === "5" && <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography><TranslatedText text={'Show setup to partner'} /></Typography>
                                <Switch onChange={(e) => setAIPromptData({ ...AIPromptData, showsetuptopartner: AIPromptData.showsetuptopartner == '0' ? '1' : '0' })} checked={Boolean(+AIPromptData.showsetuptopartner)} />
                            </Box>}
                        </Box>
                    </Paper>
                    {type == 'edit' && <Paper elevation={3} sx={{ padding: 2, height: "100%", minHeight: 450 }}>
                        <Typography sx={{ width: '100%', mb: 2 }} variant="h5"><TranslatedText text={'Functions'} /></Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', height: '83%', justifyContent: 'space-between' }}>
                            {/* <Box sx={{ overflow: 'auto', p: 2, height: '90%' }}>
                                {aiFunctions.length != 0 ? aiFunctions.map((el: any) => {
                                    return (
                                        <Paper key={el.id} variant="outlined" sx={{ padding: 1, minHeight: 60, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box sx={{ width: '70%' }}>
                                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center', mb: 1 }}>
                                                    <Typography sx={{ width: '100%', fontWeight: 600 }}>{el.name}</Typography>
                                                    <Chip label={el.required != '0' ? <TranslatedText text={'required'} /> : <TranslatedText text={'not required'} />} size="small" />
                                                    <Chip label={el.allowed_once == '1' ? <TranslatedText text={'1 time per AI call'} /> : el.allowed_once == '2' ? <TranslatedText text={'1 time per AI step'} /> : <TranslatedText text={'no call limits'} />} size="small" />
                                                    <Chip label={<TranslatedText text={'save: ' + el.save_tool_use || 'no'} />} size="small" />
                                                </Box>

                                                <Typography color="text.secondary" variant="body2" sx={{ textOverflow: 'ellipsis', overflow: "hidden", width: '100%' }}>
                                                    {truncateString(el.description, 45)}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Link to={`/aifunction?id=${el.id}&type=edit`}>
                                                    <IconButton aria-label="edit" color="primary">
                                                        <EditIcon />
                                                    </IconButton>
                                                </Link>
                                                <IconButton aria-label="delete" color="error" onClick={() => handleDeleteModalOpen(el.id)}>
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </Box>
                                        </Paper>

                                    )
                                }
                                ) : <Typography sx={{ width: '100%', textAlign: 'center', mt: '10%' }} color="text.secondary" variant="body2"><TranslatedText text={'No functions'} /></Typography>
                                }

                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 1 }}>
                                <Link to={`/aifunction?aipromptid=${id}&type=add`}>
                                    <Button variant="outlined" sx={{ width: "100%", maxWidth: 400, minWidth: 223 }}><TranslatedText text={'Add'} /></Button>
                                </Link>
                            </Box> */}

                            <Tooltip title={<TranslatedText text={"Each on a new line, format: <Master prompt>/<Function name>"} />} placement="top-end">
                                <TextField sx={{ width: "100%" }}
                                    defaultValue={AIPromptData.tools !== undefined ? AIPromptData.tools : ''}
                                    // label={<TranslatedText text={"Functions"} />}
                                    onBlur={(e) => setAIPromptData({ ...AIPromptData, tools: e.target.value !== '' ? e.target.value : '' })}
                                    multiline
                                    rows={14}
                                    
                                    fullWidth
                                    variant="outlined" />
                            </Tooltip>
                        </Box>
                    </Paper>}
                </Box>

            </Box>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 3 }}>
                <Button onClick={() => type === "edit" ? putData(AIPromptData) : postData(AIPromptData)} variant="contained" sx={{ width: "100%", maxWidth: 400, minWidth: 223 }}><TranslatedText text={'Save'} /></Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/aiprompts' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
            {/* <Modal
                open={openDeleteModal}
                onClose={handleDeleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={Modalstyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <TranslatedText text="Delete function" />
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <TranslatedText text="Are you sure you want to delete function" />
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: "space-between", paddingTop: 2 }}>
                        <Button onClick={handleDeleteModalClose}><TranslatedText text="Cancel" /></Button>
                        <Button onClick={() => handleDeleteFunction(openDeleteModal)} color='error'><TranslatedText text="Delete" /></Button>
                    </Box>
                </Box>
            </Modal> */}
        </Box>
    )
}